module.exports = __webpack_public_path__ + "media/images/application/template/conatiners_delivered_map-eb4263b7500fdb167cb48cbd43328d11.svg";